import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

interface HtmlEditorProps {
    value?: string | null;
    onChange: (html: string) => void;
    placeholder?: string;
    label?: string;
    isInvalid?: boolean;
    disabled?: boolean;
}

export function HtmlEditor({ 
    value, 
    onChange, 
    placeholder = "Enter content...", 
    label,
    isInvalid = false,
    disabled = false 
}: HtmlEditorProps) {
    
    const modules = useMemo(() => ({
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['link'],
            ['clean']
        ],
    }), []);

    const formats = [
        'header', 'bold', 'italic', 'underline',
        'list', 'align', 'link'
    ];

    const handleChange = (content: string) => {
        onChange(content);
    };

    const editorStyle = {
        border: isInvalid ? '2px solid #dc3545' : '1px solid #ced4da',
        borderRadius: '0.375rem',
        backgroundColor: disabled ? '#e9ecef' : 'white',
    };

    return (
        <div>
            {label && (
                <label className="form-label fw-bold mb-2">{label}</label>
            )}
            <div style={editorStyle} className={`html-editor-quill ${isInvalid ? 'is-invalid' : ''}`}>
                <ReactQuill
                    theme="snow"
                    value={value || ''}
                    onChange={handleChange}
                    placeholder={placeholder}
                    modules={modules}
                    formats={formats}
                    readOnly={disabled}
                    style={{
                        backgroundColor: disabled ? '#e9ecef' : 'white',
                    }}
                />
            </div>
        </div>
    );
}